"use strict";
var _a, _b, _c, _d;
exports.__esModule = true;
exports.NodeValues = exports.valuePropsByType = void 0;
var nodeDef_1 = require("../nodeDef");
var valuePropsCode;
(function (valuePropsCode) {
    valuePropsCode[valuePropsCode["code"] = 0] = "code";
    valuePropsCode[valuePropsCode["itemUuid"] = 1] = "itemUuid";
    valuePropsCode[valuePropsCode["label"] = 2] = "label";
})(valuePropsCode || (valuePropsCode = {}));
var valuePropsCoordinate;
(function (valuePropsCoordinate) {
    valuePropsCoordinate[valuePropsCoordinate["x"] = 0] = "x";
    valuePropsCoordinate[valuePropsCoordinate["y"] = 1] = "y";
    valuePropsCoordinate[valuePropsCoordinate["srs"] = 2] = "srs";
})(valuePropsCoordinate || (valuePropsCoordinate = {}));
var valuePropsDate;
(function (valuePropsDate) {
    valuePropsDate[valuePropsDate["day"] = 0] = "day";
    valuePropsDate[valuePropsDate["month"] = 1] = "month";
    valuePropsDate[valuePropsDate["year"] = 2] = "year";
})(valuePropsDate || (valuePropsDate = {}));
var valuePropsFile;
(function (valuePropsFile) {
    valuePropsFile[valuePropsFile["fileUuid"] = 0] = "fileUuid";
    valuePropsFile[valuePropsFile["fileName"] = 1] = "fileName";
    valuePropsFile[valuePropsFile["fileSize"] = 2] = "fileSize";
})(valuePropsFile || (valuePropsFile = {}));
var valuePropsTaxon;
(function (valuePropsTaxon) {
    valuePropsTaxon[valuePropsTaxon["code"] = 0] = "code";
    valuePropsTaxon[valuePropsTaxon["scientificName"] = 1] = "scientificName";
    valuePropsTaxon[valuePropsTaxon["taxonUuid"] = 2] = "taxonUuid";
    valuePropsTaxon[valuePropsTaxon["vernacularName"] = 3] = "vernacularName";
    valuePropsTaxon[valuePropsTaxon["vernacularNameUuid"] = 4] = "vernacularNameUuid";
})(valuePropsTaxon || (valuePropsTaxon = {}));
var valuePropsTime;
(function (valuePropsTime) {
    valuePropsTime[valuePropsTime["hour"] = 0] = "hour";
    valuePropsTime[valuePropsTime["minute"] = 1] = "minute";
})(valuePropsTime || (valuePropsTime = {}));
exports.valuePropsByType = (_a = {},
    _a[nodeDef_1.NodeDefType.boolean] = null,
    _a[nodeDef_1.NodeDefType.code] = valuePropsCode,
    _a[nodeDef_1.NodeDefType.coordinate] = valuePropsCoordinate,
    _a[nodeDef_1.NodeDefType.date] = valuePropsDate,
    _a[nodeDef_1.NodeDefType.decimal] = null,
    _a[nodeDef_1.NodeDefType.entity] = null,
    _a[nodeDef_1.NodeDefType.file] = valuePropsFile,
    _a[nodeDef_1.NodeDefType.integer] = null,
    _a[nodeDef_1.NodeDefType.taxon] = valuePropsTaxon,
    _a[nodeDef_1.NodeDefType.time] = valuePropsTime,
    _a[nodeDef_1.NodeDefType.text] = null,
    _a);
var getValuePropRaw = function (params) {
    var _a;
    var node = params.node, prop = params.prop, defaultValue = params.defaultValue;
    var valueProp = (_a = node.value) === null || _a === void 0 ? void 0 : _a[prop];
    return valueProp === undefined ? defaultValue : valueProp;
};
var getItemUuid = function (node) {
    return getValuePropRaw({ node: node, prop: valuePropsCode[valuePropsCode.itemUuid] });
};
var getDatePart = function (index) { return function (node) { return Number((node.value || '--').split('-')[index].trim()); }; };
var getDateYear = getDatePart(0);
var getDateMonth = getDatePart(1);
var getDateDay = getDatePart(2);
var _datePropGetters = (_b = {},
    _b[valuePropsDate.day] = getDateDay,
    _b[valuePropsDate.month] = getDateMonth,
    _b[valuePropsDate.year] = getDateYear,
    _b);
var getTaxonUuid = function (node) {
    return getValuePropRaw({ node: node, prop: valuePropsTaxon[valuePropsTaxon.taxonUuid] });
};
var _getTimePart = function (index) { return function (node) { return Number((node.value || ':').split(':')[index].trim()); }; };
var getTimeHour = _getTimePart(0);
var getTimeMinute = _getTimePart(1);
var _timePropGetters = (_c = {},
    _c[valuePropsTime.hour] = getTimeHour,
    _c[valuePropsTime.minute] = getTimeMinute,
    _c);
var _valuePropGetters = (_d = {},
    _d[nodeDef_1.NodeDefType.date] = function (prop) { return _datePropGetters[valuePropsDate[prop]]; },
    _d[nodeDef_1.NodeDefType.time] = function (prop) { return _timePropGetters[valuePropsTime[prop]]; },
    _d);
var isValueProp = function (params) {
    var nodeDef = params.nodeDef, prop = params.prop;
    return Object.values(exports.valuePropsByType[nodeDef.type] || {}).includes(prop);
};
var getValueProp = function (params) {
    var nodeDef = params.nodeDef, node = params.node, prop = params.prop;
    var propGetter = _valuePropGetters[nodeDef.type];
    return propGetter ? propGetter(prop)(node) : getValuePropRaw({ node: node, prop: prop });
};
exports.NodeValues = {
    getValueProp: getValueProp,
    isValueProp: isValueProp,
    getItemUuid: getItemUuid,
    getTaxonUuid: getTaxonUuid
};
//# sourceMappingURL=nodeValues.js.map